import { useState } from "react";
import { useAuthentication } from "hooks";
import { TabContext, TabList, TabPanel } from '@mui/lab';
import {
    Box,
    Typography,
    Tab
} from "@mui/material";
import { BasePage, NotificationTypography, ReviewList } from "components";
import LoginIcon from '@mui/icons-material/Login';

export function ReviewsPage() {
    const { user, isAuthenticated } = useAuthentication();
    const [tab, setTab] = useState('deals');

    if (!isAuthenticated) {
        return (
            <BasePage>
                <NotificationTypography
                    color="info"
                    Icon={LoginIcon}
                    title="Sign In Required"
                    message="Please sign in to view your reviews."
                    showActions={false}
                />
            </BasePage>
        );
    }

    const handleTabChange = (_, newTab) => {
        setTab(newTab);
    };

    return (
        <BasePage>
            <Typography variant="h6" mb={3}>
                Reviews
            </Typography>

            <TabContext value={tab}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleTabChange}>
                        <Tab label="Deal Reviews" value="deals" />
                        <Tab label="Restaurant Reviews" value="restaurants" />
                    </TabList>
                </Box>
                <TabPanel value="deals" sx={{ px: 0 }}>
                    <UserReviewsList
                        userId={user.uid}
                        contentFilter="deals"
                    />
                </TabPanel>
                <TabPanel value="restaurants" sx={{ px: 0 }}>
                    <UserReviewsList
                        userId={user.uid}
                        contentFilter="restaurants"
                    />
                </TabPanel>
            </TabContext>
        </BasePage>
    );
}

function UserReviewsList({ userId, contentFilter }) {
    return (
        <ReviewList
            type="user"
            userId={userId}
            contentFilter={contentFilter}
            hideCreateButton={true}
            showUserReviewsOnly={true}
        />
    );
}